
import Swiper, { Navigation, Pagination, Lazy } from 'swiper';
Swiper.use([Navigation, Pagination, Lazy]);
window.BH_SWIPER = Swiper;
import Component from 'gia/Component'

export default class SwiperComponent extends Component {

  mount() {
    (function ($) {
      if (!$('.swiper-container.is-swiper-multiple')) {
        return;
      }
      $('.swiper-container.is-swiper-multiple').each(function (index) {
        const swiper = new window.BH_SWIPER($(this)[0], {
          // Enable lazy loading
          lazy: {
            //  tell swiper to load images before they appear
            loadPrevNext: true,
            // amount of images to load
            loadPrevNextAmount: 4,
          },
          slidesPerView: 'auto',
          centeredSlides: true,
          spaceBetween: 0,
          loop: true,
          pagination: {
            el: this.querySelector('.swiper-pagination'),
            clickable: true,
          },
          navigation: {
            nextEl: this.querySelector('.swiper-button-next'),
            prevEl: this.querySelector('.swiper-button-prev')
          },

        });
        $(window).resize(function () {
          swiper.update()
        })
      });

    })(jQuery);

  }
}



